import { Component } from '@angular/core';

@Component({
  selector: 'unsaved-changes-dialog',
  templateUrl: 'unsaved-changes-dialog.component.html',
})
export class UnsavedChangesDialogComponent {

}



// WEBPACK FOOTER //
// ./src/app/components/framework/unsaved-changes-dialog/unsaved-changes-dialog.component.ts